import { createClass as _createClass, classCallCheck as _classCallCheck, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import debounce from '../../utils/debounce.esm.js';
import { generateId } from '../../utils/unique-id.esm.js';

// eslint-disable-next-line
var traceLog = function traceLog() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  if (Array.isArray(args) && typeof args[0] === 'string' && args[0].includes('------') // use '------' to turn off the tracing
  ) {
    var _console;
    // eslint-disable-next-line
    (_console = console).groupCollapsed.apply(_console, args);
    // eslint-disable-next-line
    console.trace();
    // eslint-disable-next-line
    console.groupEnd();
  }
};
var Subject = /*#__PURE__*/function () {
  function Subject(name, options) {
    var _options$debouncePeri, _options$debounceOnLo;
    _classCallCheck(this, Subject);
    _defineProperty(this, "observers", []);
    this.name = generateId("".concat(name ? name : 'subject', "-"));
    this.debouncePeriod = (_options$debouncePeri = options === null || options === void 0 ? void 0 : options.debouncePeriod) !== null && _options$debouncePeri !== void 0 ? _options$debouncePeri : options !== null && options !== void 0 && options.debounceOnLoad ? 166 : 0;
    this.debounceOnLoad = (_options$debounceOnLo = options === null || options === void 0 ? void 0 : options.debounceOnLoad) !== null && _options$debounceOnLo !== void 0 ? _options$debounceOnLo : false;
    this.initialNotification = true;
    traceLog("[".concat(this.name, "]: constructed"), this);
  }
  _createClass(Subject, [{
    key: "attach",
    value: function attach(observer) {
      this.observers.push(observer);
      traceLog("[".concat(this.name, "]: attached an observer"), this);
    }
  }, {
    key: "detach",
    value: function detach(observer) {
      traceLog("[".concat(this.name, "]: detached an observer"), this);
      this.observers = this.observers.filter(function (o) {
        return o !== observer;
      });
    }
  }, {
    key: "notify",
    value: function notify(args) {
      var _this = this;
      traceLog("[".concat(this.name, "]: notifying these observers"), this.observers);
      if (this.debounceOnLoad && this.initialNotification) {
        this.initialNotification = false;
        debounce(function () {
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }
          return _this.observers.forEach(function (o) {
            return o.apply(void 0, args);
          });
        }, this.debouncePeriod)(args);
        this.debouncePeriod = 0;
      } else if (this.debouncePeriod) {
        debounce(function () {
          for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
          }
          return _this.observers.forEach(function (o) {
            return o.apply(void 0, args);
          });
        }, this.debouncePeriod)(args);
      } else {
        this.observers.forEach(function (o) {
          return o(args);
        });
      }
    }
  }]);
  return Subject;
}();

export default Subject;
//# sourceMappingURL=event-observer.esm.js.map
